<template>
  <BaseModal
    :title="$t('common.share')"
    :is-open="isOpen"
    size="sm"
    @close="close"
  >
    <div class="flex flex-col gap-6">
      <div class="flex gap-2 justify-between flex-wrap">
        <template v-for="shareItem in shareOptions" :key="shareItem.icon">
          <NuxtLink class="block" :href="shareItem.link" target="_blank">
            <BaseIcon :name="shareItem.icon" class="h-12 w-12" size="none" />
          </NuxtLink>
        </template>
      </div>
      <div class="flex flex-col gap-4 max-w-full">
        <div
          class="w-full border h-10 border-gray-400 text-xs rounded-xl flex items-center px-4 flex-shrink overflow-hidden"
        >
          <span class="line-clamp-1 whitespace-nowrap text-gray-400">
            {{ link }}
          </span>
        </div>
        <BaseButton
          theme="primary"
          look="solid"
          class="w-full text-base"
          @click="() => copyLink(link)"
        >
          {{ $t('common.copy_link') }}
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import {
  getFacebookLink,
  getLinkedinLink,
  getTelegramLink,
  getTwitterLink,
  getWhatsappLink,
} from '~/utils/share-constructor'

interface PropsInterface {
  link: string
  title: string
  isOpen: boolean
}

const props = withDefaults(defineProps<PropsInterface>(), {
  isOpen: false,
})

const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}

const { copyLink } = useClipboardCopy()

const shareOptions = computed(() => [
  {
    icon: 'brand_facebook_circle_color',
    link: getFacebookLink(props.link),
  },
  { icon: 'brand_twitter_circle_color', link: getTwitterLink(props.link) },
  {
    icon: 'brand_linkedin_circle_color',
    link: getLinkedinLink(props.link),
  },
  {
    icon: 'brand_telegram_circle_color',
    link: getTelegramLink(props.link, props.title),
  },
  {
    icon: 'brand_whatsapp_circle_color',
    link: getWhatsappLink(props.link, props.title),
  },
])
</script>
